fx.ns("shared.popups", class ConfirmDeletePhoto extends fx.components.Popup{
    
    constructor(photo)
    {
        super(photo);
        this.contentWidth = 500;
        this.contentHeight = 240;
    }

    get photo()
    {
        return this.data;
    }


    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("click", this.close, this.cancelButton);

        this.on("ENTER", this.onConfirm, fx.keyboard);
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Etes-vous sûre ?"), className:"title center"}), {height:30, left:0, top:20, width:"100%"});
        this.addChild(new fx.components.Text({text:fx.text("Cette photo est utilisée dans votre album.<br>Elle sera supprimée de toutes les pages ou elle apparaît."), className:"text center"}), {height:80, left:0, top:80, width:"100%"});

        let hcontainer = new fx.components.HBox("buttons");

        this.okButton = new fx.components.Button({label : fx.text("Je la supprime"), type : "filled"});
        this.cancelButton = new fx.components.Button( {label :fx.text("Non")} );

        hcontainer.addChild(this.cancelButton, {width : 100});
        hcontainer.addChild(this.okButton, {width :200});

        this.addChild(hcontainer, {bottom:20, height:60, left:"center"});
    }


    onConfirm()
    {
        this.photo.delete(true);
        this.close();
    }

});